export default "__VITE_ASSET__BAHh_psq__"